import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from './error-boundary';
import { ToastViewport } from '@/components/ui/toast';
import { useToastStore } from '@/stores/toast-store';
import { usePreventZoom } from '@/hooks/use-prevent-zoom';
import { useWakeLock } from '@/hooks/use-wake-lock';

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60_000, // menu: 5-min stale-while-revalidate
        retry: 2,
        refetchOnWindowFocus: false,
      },
    },
  });
}

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(makeQueryClient);
  const toasts = useToastStore((s) => s.toasts);

  usePreventZoom();
  useWakeLock();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {children}
        <ToastViewport toasts={toasts} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
